// BlogPage.js
import React from 'react';
import { Box, Typography, Container, Breadcrumbs, Link as MuiLink, Grid, Card, CardContent, CardActions, } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

const BlogPage = () => {
  const breadcrumbs = [
    { name: 'Home', path: '/' },
    { name: 'Resources', path: '/resources' },
    { name: 'Blog', path: '/resources/blog' },
  ];

  const blogPosts = [
    {
      id: 1,
      title: 'The Future of Steel Recycling: Innovations and Trends',
      date: 'July 20, 2024',
      author: 'Jane Doe',
      excerpt: 'Explore the cutting-edge technologies and market shifts that are shaping the future of steel recycling globally...',
      link: '#blog-post-1', // Placeholder link
    },
    {
      id: 2,
      title: 'Understanding Non-Ferrous Metal Prices in Q3',
      date: 'July 15, 2024',
      author: 'John Smith',
      excerpt: 'A detailed analysis of the factors influencing non-ferrous metal prices and what to expect in the coming quarter...',
      link: '#blog-post-2', // Placeholder link
    },
    {
      id: 3,
      title: 'Sustainable Practices: How Your Scrap Contributes to a Greener Planet',
      date: 'July 10, 2024',
      author: 'Alice Johnson',
      excerpt: 'Learn about the environmental benefits of proper scrap recycling and our commitment to a circular economy...',
      link: '#blog-post-3', // Placeholder link
    },
    {
      id: 4,
      title: 'Navigating International Scrap Trade Regulations',
      date: 'July 5, 2024',
      author: 'Robert Brown',
      excerpt: 'A guide to the complex world of international regulations governing the trade of various scrap materials...',
      link: '#blog-post-4', // Placeholder link
    },
  ];

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default', p: 2 }}>
      <Container sx={{ py: { xs: 4, md: 6 }, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 1 }}>
        {/* Breadcrumbs */}
        <Box sx={{ mb: { xs: 2, md: 4 }, px: { xs: 2, md: 0 } }}>
          <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
            {breadcrumbs.map((crumb, index) => (
              crumb.path ? (
                <MuiLink component={RouterLink} to={crumb.path} key={index} underline="hover" color="text.secondary" variant="body2">
                  {crumb.name}
                </MuiLink>
              ) : (
                <Typography key={index} color="text.primary" variant="body2">{crumb.name}</Typography>
              )
            ))}
          </Breadcrumbs>
        </Box>

        <Typography variant="h3" align="center" fontWeight={700} sx={{ mb: { xs: 4, md: 6 }, color: 'text.primary' }}>
          Our Blog
        </Typography>

        <Typography variant="body1" align="center" sx={{ mb: { xs: 4, md: 6 }, maxWidth: '800px', mx: 'auto', color: 'text.secondary' }}>
          Dive into our latest articles, insights, and analyses on the global scrap and recycling industry. Our blog provides valuable information to help you stay informed and make smarter decisions.
        </Typography>

        <Grid container spacing={4}>
          {blogPosts.map((post) => (
            <Grid item xs={12} sm={6} md={4} key={post.id}>
              <Card
                sx={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  borderRadius: 2,
                  boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                  transition: 'all 0.3s ease-in-out',
                  '&:hover': {
                    transform: 'translateY(-5px)',
                    boxShadow: '0 8px 24px rgba(0,0,0,0.1)',
                  },
                }}
              >
                <CardContent sx={{ flexGrow: 1 }}>
                  <Typography variant="h6" component="div" fontWeight={600} sx={{ color: 'primary.dark', mb: 1 }}>
                    {post.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                    By {post.author} | {post.date}
                  </Typography>
                  <Typography variant="body1" color="text.primary">
                    {post.excerpt}
                  </Typography>
                </CardContent>
                <CardActions sx={{ justifyContent: 'flex-end', p: 2 }}>
                  <MuiLink component={RouterLink} to={post.link} size="small" sx={{ fontWeight: 500, color: 'primary.main' }}>
                    Read More &rarr;
                  </MuiLink>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default BlogPage;
